import _ from "lodash";

// Get Twilio Get File Status
export const getTwilioGetFileStatusLoading = (twilio) =>
  _.get(twilio, ["getTwilioGetFileStatus", "loading"], false);
export const getTwilioGetFileStatusData = (twilio) =>
  _.get(twilio, ["getTwilioGetFileStatus", "items"], null);
export const getTwilioGetFileStatusStatus = (twilio) =>
  _.get(twilio, ["getTwilioGetFileStatus", "status"], false);
  export const getTwilioGetFileStatusDataData = (item) => _.get(item, ["Data"], null);
  export const getTwilioGetFileStatusDataStatus = (item) => _.get(item, ["status"], null);
  export const getTwilioGetFileStatusDataMessage = (item) => _.get(item, ["message"], null);
// Get Twilio OTP
export const getTwilioRequestOTPLoading = (twilio) =>
  _.get(twilio, ["getTwilioRequestOtp", "loading"], false);
export const getTwilioRequestOTPData = (twilio) =>
  _.get(twilio, ["getTwilioRequestOtp", "items"], null);
export const getTwilioRequestOTPStatus = (twilio) =>
  _.get(twilio, ["getTwilioRequestOtp", "status"], false);
  export const getTwilioRequestOTPDataData = (item) => _.get(item, ["Data"], null);
  export const getTwilioRequestOTPDataStatus = (item) => _.get(item, ["status"], null);
  export const getTwilioRequestOTPDataMessage = (item) => _.get(item, ["message"], null);
  export const getTwilioRequestOTPDataPhoneNumber = (item) => _.get(item, ["phoneNumber"], null);
  

// Get Twilio GEt File
export const getTwilioGetFileLoading = (twilio) =>
  _.get(twilio, ["getTwilioGetFile", "loading"], false);
export const getTwilioGetFileData = (twilio) =>
  _.get(twilio, ["getTwilioGetFile", "items"], null);
export const getTwilioGetFileStatus = (twilio) =>
  _.get(twilio, ["getTwilioGetFile", "status"], false);
  export const getTwilioGetFileDataData = (item) => _.get(item, ["Data"], null);
  export const getTwilioGetFileDataStatus = (item) => _.get(item, ["status"], null);
  export const getTwilioGetFileDataMessage = (item) => _.get(item, ["message"], null);
  export const getTwilioGetFileDataFile = (item) => _.get(item, ["file"], null);
  export const getTwilioGetFileDataFileType = (item) => _.get(item, ["fileType"], null);
